
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-reviews",
      function () {
        return require("private-next-pages/product-reviews/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-reviews"])
      });
    }
  